"use strict";
/*
 * Created on 11 12 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataDictionaryError_1 = require("../../core/model/data-dictionary/DataDictionaryError");

var FamilyBindingConverter_1 = require("./FamilyBindingConverter");
/**
 * Implementation of {@link FamilyBindingConverter}
 *
 * @author JMe
 */


var FamilyBindingConverterImpl =
/*#__PURE__*/
function (_FamilyBindingConvert) {
  _inherits(FamilyBindingConverterImpl, _FamilyBindingConvert);

  function FamilyBindingConverterImpl() {
    _classCallCheck(this, FamilyBindingConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(FamilyBindingConverterImpl).apply(this, arguments));
  }

  _createClass(FamilyBindingConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      return {
        productId: conversions.toDocumentReferenceId(source.productId),
        sizeCharger: conversions.fromBigNumber(source.sizeCharger),
        sizeRatio: conversions.fromBigNumber(source.sizeRatio)
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      if (!source.productId) {
        throw new DataDictionaryError_1.DataDictionaryError("productId is missing!");
      }

      return {
        productId: conversions.asObject(source, 'productId', function (value) {
          return conversions.toClassReferenceId(value);
        }),
        sizeCharger: conversions.asObject(source, 'sizeCharger', function (v) {
          return conversions.toBigNumber(v);
        }),
        sizeRatio: conversions.asObject(source, 'sizeRatio', function (v) {
          return conversions.toBigNumber(v);
        })
      };
    }
  }]);

  return FamilyBindingConverterImpl;
}(FamilyBindingConverter_1.FamilyBindingConverter);

exports.FamilyBindingConverterImpl = FamilyBindingConverterImpl;